import { di } from 'react-magnetic-di';

import { useIsClientReady } from '@jira/ssr__ssr-toolkit/src/hooks/use-is-client-ready.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	type HookActionsFunction,
	type Action,
	createHook,
	createStore,
	createActionsHook,
	type BoundActions,
	type HookFunction,
} from '@atlassian/react-sweet-state';
import { BANNER_HEIGHT } from './bannerName.constants.tsx';
import type { State } from './State.types.tsx';

/**
 * @deprecated Don't do __SERVER__ checks, use `useIsInIframe`
 */
export const isInIframe = (): boolean => {
	di(window);
	if (__SERVER__) {
		return false;
	}

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	return window !== window.top;
};

export function useIsInIframe(): boolean {
	di(window);
	const isClientRender = useIsClientReady();

	if (!isClientRender) {
		return false;
	}

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	return window !== window.top;
}

// Fetching banner preferences and height in initial state to prevent layout shifts.
export const initialState: State = {
	get isDismissed() {
		return true;
	},
	get height() {
		return BANNER_HEIGHT;
	},
	hasInit: false,
};

export const actions = {
	onShow:
		(): Action<State> =>
		({ setState }) => {
			setState({
				isDismissed: false,
			});
		},
	onDismiss:
		(): Action<State> =>
		({ setState }) => {
			setState({
				isDismissed: true,
			});
		},
	setHeight:
		(height: number): Action<State> =>
		({ setState }) => {
			setState({ height });
		},
	init:
		(isDismissed: boolean): Action<State> =>
		({ setState }) => {
			setState({
				isDismissed,
				hasInit: true,
			});
		},
} as const;

type Actions = typeof actions;

const Store = createStore<State, Actions>({
	name: 'cookie-consent-banner',
	initialState,
	actions,
});

export const useCookieConsentBannerSettings: HookFunction<
	State,
	BoundActions<
		State,
		{
			readonly onShow: () => Action<State>;
			readonly onDismiss: () => Action<State>;
			readonly setHeight: (height: number) => Action<State>;
			readonly init: (isDismissed: boolean) => Action<State>;
		}
	>,
	void
> = createHook(Store);

// @ts-expect-error - TS2322 - Type 'HookActionsFunction<BoundActions<State, { readonly onShow: () => Action<State>; readonly onDismiss: () => Action<State>; readonly setWidth: (width: number) => Action<State>; readonly setHeight: (height: number) => Action<...>; }>>' is not assignable to type 'HookActionsFunction<{ readonly onShow: () => Action<State>; readonly onDismiss: () => Action<State>; readonly setWidth: (width: number) => Action<State>; readonly setHeight: (height: number) => Action<...>; }>'.
export const useCookieConsentBannerSettingsActions: HookActionsFunction<Actions> =
	createActionsHook(Store);
